
import { ErrorsTranslationType } from "../../features/errors.types";

export const errors: ErrorsTranslationType = {
  errors: {
    error: "خطأ",
    notFound: "الصفحة غير موجودة",
    deleteAccountError: "حدث خطأ أثناء حذف الحساب. يرجى المحاولة مرة أخرى.",
    loadStoryError: "حدث خطأ أثناء تحميل القصة. يرجى المحاولة مرة أخرى.",
    loadCharactersError: "حدث خطأ أثناء تحميل الشخصيات. يرجى المحاولة مرة أخرى.",
    summaryError: "حدث خطأ أثناء إنشاء الملخص. يرجى المحاولة مرة أخرى."
  }
};
